
import { defineComponent, reactive, toRefs } from 'vue'
import { useStore } from 'vuex'
import { countAd, fetchAddDrawTimes } from '@/http/api'
import { getXunJiaInfo3Cookie } from '@/composables/use-cookie-function'
import { Toast } from 'vant'
import { useRoute } from 'vue-router'
export default defineComponent({
  name: '',
  emits: ['toggleTmForWardPopup'],
  props: {
    isShowTmForWardPopup: {
      type: Boolean,
    },
  },
  setup(props, { emit }) {
    const store = useStore()
    const route = useRoute()
    const data = reactive({
      browserEnv: store.state.browserEnv,
    })
    const methods = {
      toggleTmForWardPopup(isShowTmForWardPopup: boolean) {
        emit('toggleTmForWardPopup', { isShowTmForWardPopup })
      },
      // 增加分享机会
      async addDrawTimes() {
        let cookiePhoneObj: any = getXunJiaInfo3Cookie()
        const res: any = await fetchAddDrawTimes({
          phone: cookiePhoneObj.encryptPhone,
        }) // 增加分享次数
        if (res.code === 200) {
          if (res.data.code === 0) {
            store.dispatch('getGameInfo', {
              actId: route.query.actId,
              phone: cookiePhoneObj.encryptPhone,
            }) // 更新游戏信息
          }
          Toast(res.data.msg)
        } else {
          Toast(res.messsage)
        }
      },
      // 去微信转发
      async goWeChat() {
        countAd(6565)
        // 分享配置：app跳转app分享组件生成卡片、wap跳转微信生成分享链接
        let sUserAgent = navigator.userAgent.toLowerCase()
        if (sUserAgent.indexOf('baidu') > 0) {
          Toast('百度浏览器无法唤起微信,请更换浏览器！')
        } else {
          window.location.href = 'weixin://'
          emit('toggleTmForWardPopup', { isShowTmForWardPopup: false })
          methods.addDrawTimes()
        }
      },
    }
    return {
      ...toRefs(data),
      ...methods,
    }
  },
})
